import { useRef } from 'react';

/** Keep one discovery options object so changing bootstrap peers does not leave/rejoin the room. */
export default function useStableRoomOptions({
  bootstrapPeer,
  bootstrapPeerIds = [],
  metadata,
  heartbeatIntervalMs,
  ttlMs
}) {
  const optionsRef = useRef({
    metadata: {},
    bootstrapPeerIds: [],
    heartbeatIntervalMs,
    ttlMs
  });

  Object.assign(optionsRef.current.metadata, metadata);
  optionsRef.current.heartbeatIntervalMs = heartbeatIntervalMs;
  optionsRef.current.ttlMs = ttlMs;
  optionsRef.current.bootstrapPeerIds.length = 0;
  const seen = new Set();
  for (const peerId of [bootstrapPeer, ...(bootstrapPeerIds || [])]) {
    if (!peerId || seen.has(peerId)) {
      continue;
    }
    seen.add(peerId);
    optionsRef.current.bootstrapPeerIds.push(peerId);
  }

  return optionsRef.current;
}
